<template>
    <div class="content-wrapper  " style="background-color:#eee ; height: 100%">
<!--         <preLoader v-if="loader"></preLoader>-->
        <div class="container">

            <div class="form-group" style="margin-top: 30px">
              <a @click="$router.go(-1)" class="btn btn-default">{{ $t('Back') }}</a>
            </div>


            <CRow class="justify-content-md-center">
                <CCol sm="6">
                    <CCard>

                    <form v-on:submit.prevent="saveForm()">

                        <CCardHeader>
                            <strong> کالا جدید </strong>
                            <!--                        <div class="card-header-actions">-->
                            <!--                            <a-->
                            <!--                                    href="#"-->
                            <!--                                    class="card-header-action"-->
                            <!--                                    rel="noreferrer noopener"-->
                            <!--                                    target="_blank"-->
                            <!--                            >-->
                            <!--                                <small class="text-muted">خروجی اکسل</small>-->
                            <!--                            </a>-->
                            <!--                        </div>-->
                        </CCardHeader>
                        <CCardBody  class="p-5">
                        <div class="row">
                            <div class="col-xs-12 form-group">
                                <label class="control-label">{{ $t('categories') }}</label>
                              <v-select style="min-width: 225px"
                                        v-model="item.product_category_id"
                                        :options="product_categories" label="title" :reduce="product_category => product_category.id" value="id">
                              </v-select>
                            </div>
                        </div>


                            <div class="row">
                                <div class="col-xs-12 form-group">
                                    <label class="control-label"> Code</label>
                                    <input type="text" v-model="item.code" class="form-control">
                                    <!--:class="{'has-error': errors[0].has('title')}"-->


                                    <!--<p v-if="errors[0].has('title')" class="alert-danger">-->
                                    <!--{{ errors[0].first('title') }}-->
                                    <!--</p>-->

                                </div>
                            </div>

                        <div class="row">
                            <div class="col-xs-12 form-group">
                                <label class="control-label"> {{ $t('Title') }}</label>
                                <input type="text" v-model="item.title" class="form-control">
                                <!--:class="{'has-error': errors[0].has('title')}"-->


                                <!--<p v-if="errors[0].has('title')" class="alert-danger">-->
                                <!--{{ errors[0].first('title') }}-->
                                <!--</p>-->

                            </div>
                        </div>
                        <!--<div class="row">-->
                        <!--<div class="col-xs-12 form-group">-->
                        <!--<label class="control-label">تصویر</label>-->
                        <!--<input type="text" v-model="item.image" class="form-control">-->
                        <!--</div>-->
                        <!--</div>-->
                         <!-- <div class="row">
                            <div class="col-xs-12 form-group">
                                <label class="control-label">تصویر</label>
                                <input type="text" v-model="item.image" class="form-control">
                            </div>
                        </div> -->
                        <div class="row">
                            <div class="col-xs-12 form-group">
                                <label class="control-label">{{ $t('Description') }}</label>
                                <input type="text" v-model="item.description" class="form-control">
                            </div>
                        </div>

                        <div class="row">
                            <div class="col-xs-12 form-group">
                                <label class="control-label">{{ $t('Initial amount') }}</label>
                                <input type="text" v-model="item.remaining_number" class="form-control">
                            </div>
                        </div>



                        <div class="row">
                            <div class="col-xs-12 form-group">
                                <label class="control-label">{{ $t('Price') }}</label>
                                <input type="text" v-model="item.price" class="form-control">
                            </div>
                        </div>


                        <!-- <div class="row">
                            <div class="col-xs-12 form-group">
                                <label class="control-label"></label>
                                <input type="text" v-model="item.min_time" class="form-control">
                            </div>
                        </div>

                        <div class="row">
                            <div class="col-xs-12 form-group">
                                <label class="control-label">حداکثر زمان</label>
                                <input type="text" v-model="item.max_time" class="form-control">
                            </div>
                        </div> -->
                         <!-- <div class="row">
                            <div class="col-xs-12 form-group">
                                <label class="control-label">مالیات</label>
                                <input type="text" v-model="item.tax" class="form-control">
                            </div>
                        </div> -->
<!--                        <div class="row">-->
<!--                            <div class="col-xs-12 form-group">-->
<!--                                <label class="control-label">{{ $t('Score') }}</label>-->
<!--                                <input type="text" v-model="item.score" class="form-control">-->
<!--                            </div>-->
<!--                        </div>-->
                        <!-- <div class="row">
                            <div class="col-xs-12 form-group">
                                <label class="control-label">تخفیف</label>
                                <input type="text"  v-model="item.default_discount" class="form-control">
                            </div>
                        </div> -->


                          <div class="row">
                            <div class="col-xs-12 form-group">
                              <label class="control-label">تاریخ تولید</label>
                              <custom-time-picker
                                  v-model="item.min_time"  lable="تاریخ تولید"
                                  type="date" :clearable="true" placeholder="تاریخ تولید" min="" max=""
                                  size="sm" input-class="form-control form-control-sm">
                              </custom-time-picker>
                            </div>
                          </div>
                          <div class="row">
                            <div class="col-xs-12 form-group">
                              <label class="control-label"> تاریخ انقضا</label>
                              <custom-time-picker
                                  v-model="item.max_time"  lable="تاریخ انقضا"
                                  type="date" :clearable="true" placeholder="تاریخ انقضا" min="" max=""
                                  size="sm" input-class="form-control form-control-sm">
                              </custom-time-picker>
                            </div>
                          </div>


                          <div class="row">
                            <div class="col-xs-12 form-group">
                              <label class="control-label"> سری تولید</label>
                              <input type="text" v-model="item.reference" class="form-control">
                            </div>
                          </div>



                          <div class="row">
                            <div class="col-xs-12 form-group">
                                <label class="control-label">{{ $t('Image') }}</label>
                                <div class="form-group">
                                    <div class="input-group input-file" name="Fichier1">
                                        <input type="text" class="form-control" :placeholder="placeholder" />
                                        <input type="file" class="filestyle" ref="file"
                                            @change="onFileChange($event)" />
<!--                                        <span class="input-group-btn">-->
<!--                                            <button class="btn btn-default btn-choose" type="button">{{ $t('File') }}</button>-->
<!--                                        </span>-->
                                    </div>
                                </div>
                            </div>
                        </div>


                          <div class="row">
                            <div class="col-xs-12 form-group">
                              <label class="control-label">{{ $t('unit') }} </label>
                              <select v-model="item.unit" class="form-control"  style="min-width: 225px" >
                                <option v-for="(unit,index) in units" :value="unit.id" :key="index">
                                  {{ unit.title}}
                                </option>
                              </select>
                              <!--                                <select class="form-control" v-model="item.unit ">-->
                              <!--                                    <option value="0"> {{ $t('Number') }}</option>-->
                              <!--                                    <option value="1">{{ $t('g') }}</option>-->
                              <!--                                    <option value="2">{{ $t('Kg') }}</option>-->
                              <!--                                    <option value="3">{{ $t('Liter') }}</option>-->
                              <!--                                    <option value="4">{{ $t('packet') }}</option>-->
                              <!--                                </select>-->
                            </div>
                          </div>
                        <div class="row">
                            <div class="col-xs-12 form-group">
                                <label class="control-label">{{ $t('status') }}</label>
                                <select class="form-control" v-model="item.state"  style="min-width: 225px">
                                    <option value="0">{{ $t('Inactive') }}</option>
                                    <option value="1">{{ $t('Active') }}</option>
                                </select>
                            </div>
                        </div>
                        <div class="row">
                            <div class="col-xs-12 form-group">
                                <button class="btn btn-success">{{ $t('Add') }}</button>
                            </div>
                        </div>

                        </CCardBody>
                    </form>

                    </CCard>
                </CCol>
            </CRow>
        </div>
    </div>
</template>

<script>
    const auth = {
        headers: {
            Authorization: 'bearer ' + localStorage.getItem('token')
        }

    };

    export default {
        data: function () {
            return {
                 auth: {headers: {Authorization: 'bearer ' + localStorage.getItem('token')}},
placeholder: "فایل را انتخاب کنید...",
                item: {
                    product_category_id: '',
                    
                    title: '',
                    code: '',
                    image: null,
                    description: '',
                    initial_amount: '',
                    price: '',
                    tax: 0,
                    default_discount: 0,
                    unit: '',
                    type: '',
                    state: ''
                },

                errors: [],
                loader:false,
                product_categories: [],
                units: []

            }
        },


      watch:{


        item:{
          deep: true,
          handler() {
              if (this.item.title == '' && this.product_categories.find(x => x.id == this.item.product_category_id))
              this.item.title =  this.product_categories.find(x => x.id == this.item.product_category_id).title

          }
        },
      },

        mounted() {
            axios
                .get('/api/productCategorieslist', this.auth)
                .then(response => {
                    
                    this.product_categories = response.data;
                    console.log(this.product_categories ,"k")

                })
                .catch(error => {
                    console.log(error);
                    this.errored = true
                })

          this.getUnits()

        }


        ,

        methods: {
  onFileChange(e) {

                //    console.log(e.target.files[0])
                this.item.image = this.$refs.file.files[0];
                this.placeholder = this.$refs.file.files[0].name
                console.log(this.item.image, "144")

            },
            convertNumbers2English(string) {
                if(string !==null || string !==""){
                       return string.replace(/[\u0660-\u0669]/g, function (c) {
                    return c.charCodeAt(0) - 0x0660;
                }).replace(/[\u06f0-\u06f9]/g, function (c) {
                return c.charCodeAt(0) - 0x06f0;
            });
                }
             
            },
            saveForm() {
                var app = this;
                var newItem = app.item;
                app.loader=true
                  let formData = new FormData();
                for (const key in newItem) {
                    if (newItem.hasOwnProperty(key)) {
                        const element = newItem[key];
                        formData.append(key, element)
                       console.log(key, element);
                    }
                }
                axios.post('/api/products', formData, app.auth)
                    .then(function (resp) {

                        app.$router.go(-1)

                        app.loader=false
                        console.log(app.item.product_categories_id)
                        console.log(resp);

                    })
                    .catch(
                        e => {
                            console.log(newItem);
                            console.log(e);

                            app.errors.push(e.response.data.messages);
                            app.loader=false
                        for (let value of e.response.data.messages_fa) {
//                        for (let error of Object.entries(value[1])) {
//                            console.log(app.object.entries(app.errors[0]));

                            app.$snotify.warning(value,
                                {
                                    timeout: 7000,
//                                    showProgressBar: false,
                                    closeOnClick: true,
                                    pauseOnHover: true
                                });

//                        }
                        }

                        }

                    );


            },



          pluck(array, key) {
            return array.map(function (obj) {
              return obj[key];
            });
          },

          getUnits() {
            axios
                .get('/api/unitList', this.auth)
                .then(response => {

                  this.units = response.data;
                })
                .catch(error => {
                  console.log(error);
                  this.errored = true
                })
          },

          setTitle() {
            if (this.product_categories.find(x => x.id == this.item.product_category_id))
              this.item.title =  this.product_categories.find(x => x.id == this.item.product_category_id).title
          }


        }
    }

</script>
